import { render, staticRenderFns } from "./EventosAprobacion.vue?vue&type=template&id=8600ebd2&scoped=true&"
import script from "./EventosAprobacion.vue?vue&type=script&lang=js&"
export * from "./EventosAprobacion.vue?vue&type=script&lang=js&"
import style0 from "./EventosAprobacion.vue?vue&type=style&index=0&id=8600ebd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8600ebd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VApp,VAutocomplete,VBtn,VContainer,VFlex,VLayout,VPagination})
